export enum StyleTypesEnum {
    Color = 1,
    Pixels = 2,
    Percentage = 3,
    Other = 4,
}
